import { createNewChatPostFunction, validatePostCreateAt, getIndexChatPostMsg } from '@/service/chatPostService';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { uploadFileToS3 } from '@/component/common/UploadFiles';
import Logger from '@/common/utils/Logger';
import { disableAutoScroll } from '@/component/chatThread/handler/FootprintHandler';
import _ from 'lodash';
import { getUserById, getUserDeletedInfor } from '@/service/userService';
import { getProjectById } from '@/service/projectService';
import { I18n, Storage } from 'aws-amplify';
import { cloneDeep } from 'lodash';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { createKibanaDataChat } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { getCorporationById } from '@/service/organizationService';
import { getTicketById, editTicketData } from '@/service/ticketService';
import { getFormById } from '@/service/formManagementService';

const TYPE = 'chat';

/**
 * Get delegate user detail
 * @param {*} API 
 * @param {*} chatPostMsg 
 * @param {*} setDelegateUserDetail 
 * @returns
 */
export const getDelegateUserDetail = async (API, chatPostMsg, setDelegateUserDetail) => {
    if (Utils.isEmptyString(chatPostMsg.delegateUserId)) {
        return;
    }
    let userDetail = await getUserById(API, chatPostMsg.delegateUserId);
    userDetail = Utils.isEmptyObject(userDetail) ? {} : userDetail;
    setDelegateUserDetail(userDetail);
};



/**
 * Get delegate detail
 * @param {*} delegateUser 
 * @returns delegateDetail
 */
export const getDelegateDetail = delegateUser => {
    let fullName = `${Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, delegateUser)}`;

    let fullNameByFormat = fullName;
    if (fullName.length > 50) {
        fullNameByFormat = `${fullName.slice(0, 50)}...`;
    }

    return (
        <div>
            <div className="chatBox-sub">
                <p>代理投稿</p>
                <p>ポスター: {fullNameByFormat}</p>
            </div>
        </div>
    );
};


/**
 * validateBeforeSendMsgOnEmailTicketThread
 * @param {*} corporationInfo 
 * @param {*} projectDetail 
 * @param {*} ticketInfoRealtime 
 * @returns 
 */
const validateBeforeSendMsgOnEmailTicketThread = async (corporationInfo, projectDetail, ticketInfoRealtime) => {
    let response = {
        status: true,
        msg: ''
    }

    // Ticket removed phisical
    if (Utils.isEmptyObject(ticketInfoRealtime)) {
        return {
            status: false,
            msg: I18n.get('COMMSG002')
        }
    }

    // Ticket deleted
    if (ticketInfoRealtime?.deletedAt) {
        return {
            status: false,
            msg: I18n.get('MSG-CM-DELETED-TICKET')
        }
    }

    // Ticket archived
    if (ticketInfoRealtime.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED) {
        return {
            status: false,
            msg: I18n.get('MSG-CM-CHANGED-DATA')
        }
    }

    const ticketStatus = Utils.convertJSONDataToObject(ticketInfoRealtime.status)
    // If ticket status is DONE and Changed type to general or Offed email function
    if (
        ticketStatus.value === Constant.STATUS_NO.DONE && (
            Utils.isPublicOffDeskOff(projectDetail) ||
            !Utils.isEnableCreateEmailTicketModeOnSkipProjectType(corporationInfo, projectDetail)
        )
    ) {
        return {
            status: false,
            msg: I18n.get('MSG-CM-CHANGED-DATA')
        };
    }

    // validate realtime status
    let currentStatus = ticketInfoRealtime.status;
    if (currentStatus) {
        currentStatus = Utils.convertJSONDataToObject(currentStatus);
    }

    if (currentStatus?.status) {
        let currentStatusDetail = await getFormById(null, currentStatus?.status);
        if (!Utils.isEmptyObject(currentStatusDetail)) {
            let currentStatusDetailStructure = currentStatusDetail.structure;
            if (currentStatusDetailStructure) {
                currentStatusDetailStructure = Utils.convertJSONDataToObject(currentStatusDetailStructure);

                let isDisableChat = Utils.isDisableEditEmailTicket(ticketInfoRealtime, projectDetail, corporationInfo, currentStatusDetailStructure?.no);
                if (isDisableChat) {
                    return {
                        status: false,
                        msg: I18n.get('MSG-CM-CHANGED-DATA')
                    }; 
                }
            }
        }
    }
    
    return response;
}

export const validateBeforeHandleChatInEmailTicket = async (API, ticketInfo) => {
    const [corporationInfo, projectDetail, ticketInfoRealtime] = await Promise.all([
        getCorporationById(API, ticketInfo.affiliationOrganization),
        getProjectById(API, ticketInfo.affiliationProject),
        getTicketById(API, ticketInfo.id)
    ]);

    let validateData = await validateBeforeSendMsgOnEmailTicketThread(corporationInfo, projectDetail, ticketInfoRealtime)
    return validateData
}


/**
 * Handle submit msg
 * @param {*} params
 * @returns msg
 */
export const onSubmitCreateMsg = async ({
    setIsCreateNewMsg,
    isDelegateThread,
    isPostCreatedAtCurrentTime,
    postCreatedAtDate,
    postCreatedAtTime,
    ticketInfo,
    setMessageError,
    corporationId,
    userDetail,
    userDelegateCreateTicketDetail,
    chatThreadId,
    setChatPostAllList,
    API,
    setChatPostInsertFail,
    setChatPostUpdate,
    txtChatPostRef,
    selectedProjectId,
    contentPost,
    mentionsList,
    selectThread,
    corporationDetail,
    projectInuseDetail,
    isDeliver,
    setCreateMsgErr,
    setIsLoading,
    setLastedSendMsgIdState,
    setIsDeliver,
    statusSend,
    isSentMessage
}) => {
    const isChatInTicketEmailCustomerThread = ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL && selectThread?.threadType === Constant.THREAD_TYPE.CUSTOMER;
    const isCustomerThreadChat = ticketInfo?.ticketType !== Constant.TICKET_TYPE.EMAIL && (selectThread?.threadType === Constant.THREAD_TYPE.CUSTOMER || selectThread?.threadType === Constant.THREAD_TYPE.ESCALATION)

    if (isChatInTicketEmailCustomerThread) {
        if (setIsLoading) {
            setIsLoading(true);
        }
    }

    // disable auto scroll
    disableAutoScroll(true);
    // set is create new msg
    setIsCreateNewMsg(true);
    let affiliationProject = selectedProjectId;

    let dataValidate = {
        isDelegateThread: isDelegateThread,
        isPostCreatedAtCurrentTime: isPostCreatedAtCurrentTime,
        postCreatedAtDate: postCreatedAtDate,
        postCreatedAtTime: postCreatedAtTime,
        ticketCreatedAt: ticketInfo.createdAt,
    };
    let valid = validatePostCreateAt(dataValidate);
    if (!Utils.isEmptyString(valid.message)) {
        setMessageError(valid.message);
        return false;
    }
    let creatorId = userDetail.id;
    let delegateUserId = null;

    // get user detail of post msg
    let userDetailPostMsg = userDetail;
    if (isDelegateThread) {
        delegateUserId = userDetail.id;
        creatorId = userDelegateCreateTicketDetail
            ? userDelegateCreateTicketDetail.id
            : userDetail.id;
        affiliationProject = userDelegateCreateTicketDetail?.affiliationProject ? userDelegateCreateTicketDetail?.affiliationProject : ''
        if (typeof affiliationProject != 'string' && affiliationProject?.length > 0) affiliationProject = affiliationProject[0];
        // get user detail of post msg
        userDetailPostMsg = userDelegateCreateTicketDetail;
    }
    
    try {
        // Validate before send chat in email ticket thread chat 
        if (ticketInfo.ticketType === Constant.TICKET_TYPE.EMAIL) {
            // as of now, apply richtext for customer thread, so we don't need escape html characters in here
            if(selectThread.threadType !== Constant.THREAD_TYPE.CUSTOMER)
                contentPost = Utils.escapeHtmlCharacters(contentPost);
            
            let validateData = await validateBeforeHandleChatInEmailTicket(API, ticketInfo)
            if (!validateData.status) {
                if (setCreateMsgErr) {
                    setCreateMsgErr({ isShow : true, msg: validateData.msg ? validateData.msg : I18n.get('MSG-CM-CHANGED-DATA') });
                }
                return false;
            }
        }

        Logger.info(`Start send post: ${contentPost}`);
        console.time('time-send-request-create-post');
        let currentTime = new Date();
        let createdAt = valid.data || null;
        
        mentionsList = !Utils.isEmptyArray(mentionsList) ? [...new Set(mentionsList)] : [];

        let inputChatPost = {
            createNewChatPostRequestDto: {
                ticketAffiliationOrganization: ticketInfo?.affiliationOrganization ? ticketInfo?.affiliationOrganization : corporationId,
                ticketAffiliationProject: ticketInfo?.affiliationProject ? ticketInfo?.affiliationProject : affiliationProject,
                corporationId: corporationId,
                postType: Constant.POST_TYPE.MSG,
                chatThreadId: chatThreadId,
                content: contentPost,
                creatorId: creatorId,
                delegateUserId: delegateUserId,
                affiliationProject: affiliationProject,
                status: Constant.CHAT_POST_STATUS.UN_READ,
                seq: currentTime.getTime() + '',
                mention: mentionsList,
                ticketId: ticketInfo.id
            },
        };

        if (createdAt) {
            inputChatPost = {
                ...inputChatPost,
                createNewChatPostRequestDto: {
                    ...inputChatPost.createNewChatPostRequestDto,
                    createdAt: createdAt
                }
            };
        }
        if (statusSend) {
            inputChatPost = {
                ...inputChatPost,
                createNewChatPostRequestDto: {
                    ...inputChatPost.createNewChatPostRequestDto,
                    statusUpdateForTicket: statusSend,
                    isSentMessage: isSentMessage
                }
            };
        }
        if (isChatInTicketEmailCustomerThread) {
            let deliverInfo = {
                status: isDeliver ? Constant.DELIVER_STATUS.DELIVER : Constant.DELIVER_STATUS.UNDELIVER,
                deliverAt: isDeliver ? new Date().toISOString() : null,
                sender: isDeliver ? creatorId : '',
            }
            inputChatPost = {
                ...inputChatPost,
                createNewChatPostRequestDto: {
                    ...inputChatPost.createNewChatPostRequestDto,
                    deliverInfo
                }
            };
        };

        if (isCustomerThreadChat) {
            let deliverAt = isSentMessage ? new Date().toISOString() : null;
            if (valid?.data) {
                deliverAt = valid.data;
                inputChatPost.createNewChatPostRequestDto.updatedAt = valid.data;
            }
            let deliverInfo = {
                status: isSentMessage
                    ? Constant.DELIVER_STATUS.DELIVER
                    : Constant.DELIVER_STATUS.UNDELIVER,
                deliverAt: deliverAt,
                sender: isSentMessage ? creatorId : ''
            };

            if (!isSentMessage) {
                inputChatPost.createNewChatPostRequestDto.affiliationProject =
                    inputChatPost.createNewChatPostRequestDto.ticketAffiliationProject;
            }

            inputChatPost = {
                ...inputChatPost,
                createNewChatPostRequestDto: {
                    ...inputChatPost.createNewChatPostRequestDto,
                    deliverInfo
                }
            };
        }
        if (setIsDeliver) {
            setIsDeliver(false);
        }

        setMessageError('');
        createNewChatPostFunction(API, inputChatPost)
            .then(async (post) => {
                if (post != null) {
                    if (setLastedSendMsgIdState && isChatInTicketEmailCustomerThread) {
                        setLastedSendMsgIdState(post.id);
                    }
                    if (isChatInTicketEmailCustomerThread) {
                        if (setIsLoading) {
                            setIsLoading(false);
                        }
                    }

                    setChatPostAllList({
                        type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.PUSH,
                        post: {
                            ...inputChatPost.createNewChatPostRequestDto,
                            userDetailPostMsg: userDetailPostMsg,
                            createdAt: post.createdAt
                        },
                    });

                    post.userDetailPostMsg = userDetailPostMsg;
                    if (!Utils.isEmptyObject(post)) {
                        setChatPostUpdate(post);

                        let isLogKibana = isLogKibanaByChat(ticketInfo, selectThread, projectInuseDetail, inputChatPost?.createNewChatPostRequestDto?.deliverInfo);
                        if (isLogKibana) {
                            createKibanaDataChat(
                                selectThread,
                                API,
                                corporationDetail,
                                projectInuseDetail,
                                userDetail,
                                ticketInfo
                            );
                        }
                    }
                } else {
                    Logger.info(`createNewChatPost - fail !`);
                    setChatPostInsertFail({
                        status: false,
                        data: {
                            ...inputChatPost.createNewChatPostRequestDto,
                            userDetailPostMsg: userDetailPostMsg
                        },
                    });

                    if (isChatInTicketEmailCustomerThread) {
                        if (setIsLoading) {
                            setIsLoading(false);
                        }
                    }
                }
            })
            .finally(() => {
                if (setIsLoading) {
                    setIsLoading(false);
                }
                console.timeEnd('time-send-request-create-post');
                Logger.info(`END send post: ${contentPost}`);
            });

            if (isChatInTicketEmailCustomerThread) {
                if (setIsLoading) {
                    setIsLoading(false);
                }
            }
        return true
    } catch (error) {
        Logger.error('exception handleOnKeyPress enter', error);
        console.timeEnd('time-send-request-create-post');
        Logger.info(`END send post: ${contentPost}`);
    }
};

export const onResendMessage = async (API, inputChatPost, userDetail, setChatPostUpdate, setChatPostInsertFail) => {
   console.log('inputChatPost :>> ', inputChatPost);
    createNewChatPostFunction(API, inputChatPost)
        .then((post) => {
            if (!Utils.isEmptyObject(post)) {
                post.userDetailPostMsg = userDetail;
                Logger.info(`createNewChatPost - chatPost msg new:`, post);
                if (!Utils.isEmptyObject(post)) {
                    setChatPostUpdate(post);
                }
            } else {
                Logger.info(`createNewChatPost - fail !`);
                setChatPostInsertFail({
                    status: false,
                    data: {
                        ...inputChatPost.createNewChatPostRequestDto,
                        userDetailPostMsg: userDetail
                    },
                });
            }
        })
}

export const createChatPostFile = async (API, createNewChatPostRequestDto) => {
    try {
        Logger.info(`Start send post: ${createNewChatPostRequestDto.content}`);
        console.time('time-send-request-create-post');
        let inputChatPost = {
            createNewChatPostRequestDto: createNewChatPostRequestDto,
        };

        let post = await createNewChatPostFunction(API, inputChatPost);
        if (post != null) {
            Logger.info(`post:`, post);
            // set msg images
        }
    } catch (error) {
        Logger.error('exception handleOnKeyPress enter', error);
    }
    console.timeEnd('time-send-request-create-post');
    Logger.info(`END send post: ${createNewChatPostRequestDto.content}`);
};

export const onSubmitUploadFile = async (
    file,
    {
        API,
        corporationId,
        userDetail,
        isDelegateThread,
        isPostCreatedAtCurrentTime,
        postCreatedAtDate,
        postCreatedAtTime,
        ticketInfo,
        setMessageError,
        userDelegateCreateTicketDetail,
        selectThread,
        chatThreadId,
        fileUploadedList,
        setFileUploadedList,
        setChatPostAllList,
        setIsModalUploadFileError,
        setFileUploading,
        selectedProjectId,
        corporationDetail,
        projectInuseDetail,
        chatPostAllList,
        statusSend,
        isSentMessage
    }
) => {
    let dataValidate = {
        isDelegateThread: isDelegateThread,
        isPostCreatedAtCurrentTime: isPostCreatedAtCurrentTime,
        postCreatedAtDate: postCreatedAtDate,
        postCreatedAtTime: postCreatedAtTime,
        ticketCreatedAt: ticketInfo.createdAt,
    };
    const isCustomerThreadChat = [
        Constant.TICKET_TYPE.EXTERNAL_QA,
        Constant.TICKET_TYPE.INTERNAL_QA,
        Constant.TICKET_TYPE.DELEGATE,
        Constant.TICKET_TYPE.ESCALATION,
        Constant.TICKET_TYPE.QA,
        Constant.TICKET_TYPE.BROADCAST_CHILD,
        Constant.TICKET_TYPE.BROADCAST_PARENT,
        Constant.TICKET_TYPE.NOTICE
    ].includes(ticketInfo.ticketType) && (selectThread?.threadType === Constant.THREAD_TYPE.CUSTOMER || selectThread?.threadType === Constant.THREAD_TYPE.ESCALATION)
    let valid = validatePostCreateAt(dataValidate);
    if (!Utils.isEmptyString(valid.message)) {
        setMessageError(valid.message);
        return;
    }
    let creatorId = userDetail.id
    const currentClientId = localStorageUtil.getClientUUid();
    // get user detail of post msg
    let userDetailPostMsg = userDetail;
    let affiliationProject = selectedProjectId

    let delegateUserId = null;
    let createdAt;
    if (isDelegateThread) {
        delegateUserId = userDetail.id;
        creatorId = userDelegateCreateTicketDetail
            ? userDelegateCreateTicketDetail.id
            : userDetail.id;
        affiliationProject = userDelegateCreateTicketDetail?.affiliationProject ? userDelegateCreateTicketDetail?.affiliationProject : ''
        // get user detail of post msg
        userDetailPostMsg = userDelegateCreateTicketDetail;
        if (!isPostCreatedAtCurrentTime) {
            createdAt = valid.data;
        }
    }
    let currentTime = new Date();
    let keyFileAtS3 = `${corporationId}/ticket/${selectThread.ticketId}/chatThread/${chatThreadId}/${userDetail?.id}/${currentTime.getTime()}/${file.name}`;
    let fileUpload = { file: file, progress: 0, status: true, key: keyFileAtS3 };
    let fileUploadList = [...fileUploadedList, fileUpload];
    setFileUploadedList(fileUploadList);

    let isImage = file && file['type'].split('/')[0] === 'image';
    let createNewChatPostRequestDto = {
        ticketAffiliationOrganization: ticketInfo?.affiliationOrganization ? ticketInfo?.affiliationOrganization : corporationId,
        ticketAffiliationProject: ticketInfo?.affiliationProject ? ticketInfo?.affiliationProject : affiliationProject,
        corporationId: corporationId,
        postType: isImage ? Constant.POST_TYPE.IMAGE : Constant.POST_TYPE.FILE,
        chatThreadId: chatThreadId,
        content: file.name,
        creatorId: creatorId,
        delegateUserId: delegateUserId,
        fileUrl: keyFileAtS3,
        status: Constant.CHAT_POST_STATUS.UN_READ,
        affiliationProject: affiliationProject,
        fileSize: file.size,
        seq: currentTime.getTime() + '',
        clientUUId: currentClientId,
        ticketId: ticketInfo.id
    };
    if (createdAt) {
        createNewChatPostRequestDto['createdAt'] = createdAt;
    }

    if (statusSend) {
        createNewChatPostRequestDto['statusUpdateForTicket'] = statusSend;
        createNewChatPostRequestDto['isSentMessage'] = isSentMessage;
    }

    let dummyCreatedAt = new Date();
    if (!createdAt && !Utils.isEmptyArray(chatPostAllList)) {
        let maxCreatedAt = 0;
        chatPostAllList.forEach(msg => {
            if (msg.createdAt && new Date(msg.createdAt).getTime() > maxCreatedAt) {
                maxCreatedAt = new Date(msg.createdAt).getTime();
            }
            if (msg.updatedAt && new Date(msg.updatedAt).getTime() > maxCreatedAt) {
                maxCreatedAt = new Date(msg.updatedAt).getTime();
            }
        })

        if (maxCreatedAt) {
            dummyCreatedAt = new Date(maxCreatedAt + 1);
        }
    };

    if (isCustomerThreadChat) {
        let deliverAt = isSentMessage ? new Date().toISOString() : null;
        if (valid?.data) {
            deliverAt = valid.data;
            createNewChatPostRequestDto.updatedAt = valid.data;
        }

        let deliverInfo = {
            status: isSentMessage
                ? Constant.DELIVER_STATUS.DELIVER
                : Constant.DELIVER_STATUS.UNDELIVER,
            deliverAt: deliverAt,
            sender: isSentMessage ? creatorId : ''
        };
        if (!isSentMessage) {
            createNewChatPostRequestDto.affiliationProject =
                createNewChatPostRequestDto.ticketAffiliationProject;
        }

        createNewChatPostRequestDto = {
            ...createNewChatPostRequestDto,
            deliverInfo
        };
    }

    setChatPostAllList({
        type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.PUSH,
        post: {
            ...createNewChatPostRequestDto,
            userDetailPostMsg: userDetailPostMsg,
            createdAt: createdAt || dummyCreatedAt
        },
    });


    setMessageError('');
    let uploadResult = await uploadFileToS3(setFileUploading, fileUpload, API, TYPE).then(async (data) => {
        Logger.info('1.Result uploading file: ', data);
        if (data) {
            let msgUploadFile = await createChatPostFile(API, createNewChatPostRequestDto);

            let fileUploadIndex = chatPostAllList.findIndex(msg => msg.fileUrl === keyFileAtS3);
            if (fileUploadIndex !== -1) {
                setChatPostAllList({
                    type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.REPLACE,
                    newPost: {
                        ...createNewChatPostRequestDto,
                        userDetailPostMsg: userDetailPostMsg,
                        createdAt: msgUploadFile.createdAt
                    },
                    postIndex: fileUploadIndex,
                });
            }

            let isLogKibana = isLogKibanaByChat(ticketInfo, selectThread, projectInuseDetail, createNewChatPostRequestDto?.deliverInfo);
            if (isLogKibana) {
                createKibanaDataChat(
                    selectThread,
                    API,
                    corporationDetail,
                    projectInuseDetail,
                    userDetail,
                    ticketInfo
                )
            }
            return true;
        } else {
            let files = [...fileUploadList];
            setIsModalUploadFileError(true);
            let fileUploadInfor = _.find(files, ['key', keyFileAtS3]);
            if (typeof fileUploadInfor !== 'undefined') {
                fileUploadInfor.status = false;
                setFileUploadedList(files);
                Logger.info('2. Result uploading file: ', files);
            }
            return false;
        }
    });
    return uploadResult;
};

/**
 * 
 * @param {*} API 
 * @param {*} corporationId 
 * @param {*} post 
 * @param {*} chatPostAllList 
 * @param {*} setChatPostAllList 
 * @param {*} fileUploadedList 
 * @param {*} setFileUploadedList 
 * @param {*} isDataChanged 
 * @param {*} setIsDataChanged 
 * @param {*} userDetail 
 * @param {*} userChatList 
 * @param {*} setUserChatList 
 */
export const addChatPostToList = (
    API,
    corporationId,
    post,
    chatPostAllList,
    setChatPostAllList,
    fileUploadedList,
    setFileUploadedList,
    isDataChanged,
    setIsDataChanged,
    userDetail,
    userChatList,
    setUserChatList
) => {
    updateUserDetailPostMsg(API, post, userChatList, setUserChatList).then(() => {
    if (post.postType !== Constant.POST_TYPE.MSG && !Utils.isEmptyString(post.fileUrl)) {
        let fileUploadInfor = _.find(chatPostAllList, ['fileUrl', post.fileUrl]);
        if (typeof fileUploadInfor !== 'undefined') {
            let fileUploadIndex = chatPostAllList.indexOf(fileUploadInfor);
            setChatPostAllList({
                type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.REPLACE,
                newPost: post,
                postIndex: fileUploadIndex,
            });
            if (fileUploadedList.length > 0) {
                let newFileUploadedList = JSON.parse(JSON.stringify(fileUploadedList));
                _.remove(newFileUploadedList, function (file) {
                    return post.fileUrl === file.key;
                });
                setFileUploadedList(newFileUploadedList);
            }
            setIsDataChanged(!isDataChanged);
            return;
        }
    }
    if (
        post.postType === Constant.POST_TYPE.MSG &&
        (post.creatorId === userDetail.id || post.delegateUserId === userDetail.id) &&
        post.corporationId === corporationId
    ) {
        let msgIndex = getIndexChatPostMsg(chatPostAllList, post);
        if (msgIndex >= 0) {
            setChatPostAllList({
                type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.REPLACE,
                newPost: post,
                postIndex: msgIndex,
            });
            setIsDataChanged(!isDataChanged);
            return;
        }
    }
    setChatPostAllList({
        type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.PUSH,
        post: post,
    });
    setIsDataChanged(!isDataChanged);
    });
};

/**
 *
 * @param {*} post
 * @param {*} chatPostAllList
 * @param {*} setChatPostAllList
 * @param {*} isDataChanged
 * @param {*} setIsDataChanged
 */
export const deleteChatPostToList = (
    post,
    chatPostAllList,
    setChatPostAllList,
    isDataChanged,
    setIsDataChanged
) => {
    // delete msg
    let findById = true;
    let msgIndex = getIndexChatPostMsg(chatPostAllList, post, findById);
    if (msgIndex >= 0) {
        let chatPostAllListNew = [...chatPostAllList];
        chatPostAllListNew.splice(msgIndex, 1);
        setChatPostAllList({
            type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.INITIAL,
            posts: chatPostAllListNew ? chatPostAllListNew : [],
        });
        setIsDataChanged(!isDataChanged);
    }
};

/**
 *
 * @param {*} post
 * @param {*} chatPostAllList
 * @param {*} setChatPostAllList
 * @param {*} isDataChanged
 * @param {*} setIsDataChanged
 */
export const updateChatPostToList = (
    post,
    chatPostAllList,
    setChatPostAllList,
    isDataChanged,
    setIsDataChanged
) => {
    let findById = true;
    let msgIndex = getIndexChatPostMsg(chatPostAllList, post, findById);
    if (msgIndex >= 0) {
        setChatPostAllList({
            type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.REPLACE,
            newPost: post,
            postIndex: msgIndex,
        });
        setIsDataChanged(!isDataChanged);
    }
};



/**
 * Is push delegate post msg
 * isPush: delegate thread, customer thread
 * @param {*} isEnableChat 
 * @param {*} selectThread 
 * @param {*} ticketListType 
 * @param {*} ticketInfo
 * @param {*} escalationThread
 * @returns isPushDelegatePostMsg
 */
export const isPushDelegatePostMsg = (isEnableChat, selectThread, panelType, ticketInfo, escalationThread) => {
    if(ticketInfo?.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT){
        return false
    }

    if(ticketInfo.ticketType === Constant.TICKET_TYPE.EMAIL){
        return false;
    }


    // read id from escalation thread list
    let escalationThreadIdList = escalationThread.map(item => {
        return item['id'];
    });
     return isEnableChat && (
        Constant.THREAD_TYPE.CUSTOMER === selectThread.threadType ||
        (Constant.TICKET_TYPE.ESCALATION === ticketInfo.ticketType && Constant.THREAD_TYPE.ESCALATION === selectThread.threadType)
    )
        && panelType.includes(Constant.TYPE_GET_TICKET_LIST.HELPDESK) 
        && !escalationThreadIdList.includes(selectThread.id)
        && ![
            Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT,
            Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT,
            // check notice ticket
            Constant.TICKET_TYPE.BROADCAST_PARENT,
            Constant.TICKET_TYPE.BROADCAST_CHILD,
            Constant.TICKET_TYPE.NOTICE
        ].includes(ticketInfo.ticketType); 
};



/**
 * Check disable user list delegate msg
 * @param {*} ticketInfo 
 */
export const checkDisableUserListDelegateMsg = async args => {
    let isDisable = true;
    try {
        let projectOrigin = args.ticketDetailSelected.projectOrigin;
        if (projectOrigin === Constant.ANONYMOUS_USER_ID) {
            return args.setIsDisableUserListDelegateMsg(false)
        }
        let project = await getProjectById(args.API, args.ticketDetailSelected.projectOrigin);

        // disable if project is: customer or base project
        isDisable = !Utils.isEmptyObject(project) &&
            (Utils.isEmptyArray(args.userGuestList)
                || Constant.PROJECT_TYPE.BASE === project.type
                || Constant.PROJECT_TYPE.CUSTOMER === project.type
                // disable if project only PM
                || (args.userGuestList.length === 1 && args.userGuestList[0].id === args.userDelegateCreateTicketDetail.id)
            );
    } catch (err) {
        console.error('isDisableUserListDelegateMsg error: ', err);
        isDisable = false;
    }
    args.setIsDisableUserListDelegateMsg(isDisable);
};

export const getInfomationChatPostList = (allThread,chatPostList) => {
    let chatPostListUpdate = chatPostList.map((item, index) => {
        if(item.chatThreadId === allThread.customerThread?.id) {
            return {
                ...item,
                colorChatThread: allThread.customerThread?.colorChatThread,
                colorTabThread: allThread.customerThread?.colorTabThread,
                threadName: I18n.get('USER07BTN006')
            }
        }

        if(item.chatThreadId === allThread.internalThread?.id) {
            return {
                ...item,
                colorChatThread: allThread.internalThread?.colorChatThread,
                colorTabThread: allThread.internalThread?.colorTabThread,
                threadName: I18n.get('USER07BTN007')
            }
        }

        if(item.chatThreadId === allThread.customerReferenceThread?.id) {
            return {
                ...item,
                colorChatThread: allThread.customerReferenceThread?.colorChatThread,
                colorTabThread: allThread.customerReferenceThread?.colorTabThread,
                threadName: I18n.get('USER07BTN005')
            }
        }
        let escalateThread =  cloneDeep(allThread.escalationThread);

        let indexEscalate  = Utils.findIndexInArrayById(item.chatThreadId, escalateThread);
        return {
            ...item,
            colorChatThread: Constant.COLOR_THREAD_CHAT.ESCALATE_CHAT,
            colorTabThread: Constant.COLOR_THREAD_CHAT.ESCALATE_TAB,
            threadName: escalateThread[indexEscalate]?.projectName
        }
    })

    return chatPostListUpdate;
}

/**
 * 
 * @param {*} API 
 * @param {*} post 
 * @param {*} userChatList 
 * @param {*} setUserChatList 
 */
const updateUserDetailPostMsg = async (API, post, userChatList, setUserChatList) => {
    let userDetailPostMsg = _.find(userChatList, ['id', post.creatorId]);

    if (Utils.isEmptyObject(userDetailPostMsg) || !userDetailPostMsg.avatar) {
        userDetailPostMsg = await getUserById(API, post.creatorId);

        if (Utils.isEmptyObject(userDetailPostMsg)) {
            userDetailPostMsg = getUserDeletedInfor(post.creatorId);
        }
        if(userDetailPostMsg?.image){
            userDetailPostMsg.avatar = await Storage.get(userDetailPostMsg?.image);
        }else{
            userDetailPostMsg.avatar = Constant.AVATAR_DEFAULT
        }
        
        userChatList.push(userDetailPostMsg);
    }

    // update id for anonymous user
    if(Utils.isEmptyString(userDetailPostMsg.id) && post.creatorId?.includes('anonymous_')){
        userDetailPostMsg.id = post.creatorId;
    }
    post.userDetailPostMsg = userDetailPostMsg;

    //get mention list detail
    if(!Utils.isEmptyArray(post.mention)) {
        let listMentionDetail = await Promise.all(post.mention?.map(userId => {
            let userMentionDetail = userChatList.find(user => user.id === userId)
            if(Utils.isEmptyObject(userMentionDetail)) {
                return getUserById(API, userId);
            } else {
                return userMentionDetail;
            }
        }))
        userChatList = [...userChatList, ...listMentionDetail]
    }

    setUserChatList(userChatList);
};

/**
 * 
 * @param {*} ticketInfo 
 * @param {*} selectThread 
 */
export const isEmailTicketCustomerChatthread = (ticketInfo, selectThread) => {
    return (ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL) && 
        (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER)
}

/**
 * 
 * @param {*} ticketInfo 
 * @param {*} selectThread 
 * @param {*} currentPost
 */
 export const isEmailMessUndeliver = (ticketInfo, selectThread, currentPost) => {
    if (![Constant.TICKET_TYPE.EMAIL, Constant.TICKET_TYPE.EMAIL_REPLY].includes(ticketInfo?.ticketType)) return false;

    if (selectThread.threadType !== Constant.THREAD_TYPE.CUSTOMER) return false;
    
    return !currentPost?.deliverInfo?.status;
}

/**
 * 
 * @param {*} ticketInfo 
 */
 export const isEmailTicket = (ticketInfo, selectThread) => {
    return (ticketInfo?.ticketType === Constant.TICKET_TYPE.EMAIL)
}


/**
 * deliverMsg
 * @param {*} chatPostId 
 * @param {*} ticketId 
 * @param {*} userDetail 
 * @param {*} setIsLoading 
 * @param {*} setIsOpenModalReloadPage 
 * @returns 
 */
export const deliverEmailMsg = async (
    chatPostId,
    ticketId,
    userDetail,
    setIsLoading,
    setIsOpenModalReloadPage,
    reloadTicketDetail,

    dataForLog
) => {
    setIsLoading(true);
    await Utils.delay(1000);
    let updateData = {
        currentUserMail: userDetail?.mail,
        corporationId: userDetail?.affiliationOrganization,
        ticketType: Constant.TICKET_TYPE.EMAIL,
        ticketId: ticketId,
        currentUserId: userDetail?.id,
        chatPostId: chatPostId,
        updateMethod: Constant.UPDATE_TICKET_METHOD.DELIVER_REPLY_EMAIL_TICKET
    };
    const delieverResponse = await editTicketData(null, updateData);

    if (delieverResponse?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
        setIsLoading(false);
        setIsOpenModalReloadPage(true);
        return;
    }
    let deliverInfo = {
        status: Constant.DELIVER_STATUS.DELIVER
    }
    let isLogKibana = isLogKibanaByChat(dataForLog.ticketInfo, dataForLog.selectThread, dataForLog.projectInuseDetail, deliverInfo);
    if (isLogKibana) {
        createKibanaDataChat(
            dataForLog.selectThread,
            dataForLog.API,
            dataForLog.corporationDetail,
            dataForLog.projectInuseDetail,
            userDetail,
            dataForLog.ticketInfo
        );
    }

    reloadTicketDetail();

    setIsLoading(false);
};

export const deliverMsg = async (
    chatPostId,
    ticketId,
    userDetail,
    funcstionParams,
    ticketInfo,
    dataForLog
) => {
    funcstionParams?.setIsLoading(true);
    await Utils.delay(1000);
    let updateData = {
        currentUserMail: userDetail?.mail,
        corporationId: userDetail?.affiliationOrganization,
        ticketId: ticketId,
        currentUserId: userDetail?.id,
        chatPostId: chatPostId,
        ticketType: ticketInfo.ticketType,
        updateMethod: Constant.UPDATE_TICKET_METHOD.DELIVER_UNSENT_MESSAGE
    };
    const delieverResponse = await editTicketData(null, updateData);

    if (delieverResponse?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
        funcstionParams?.setIsLoading(false);
        funcstionParams?.setIsOpenModalReloadPage(true);
        return;
    }
    let deliverInfo = {
        status: Constant.DELIVER_STATUS.DELIVER
    };
    let isLogKibana = isLogKibanaByChat(
        dataForLog.ticketInfo,
        dataForLog.selectThread,
        dataForLog.projectInuseDetail,
        deliverInfo
    );
    if (isLogKibana) {
        createKibanaDataChat(
            dataForLog.selectThread,
            dataForLog.API,
            dataForLog.corporationDetail,
            dataForLog.projectInuseDetail,
            userDetail,
            dataForLog.ticketInfo
        );
    }

    funcstionParams?.reloadTicketDetail();

    funcstionParams?.setIsLoading(false);
};

const isLogKibanaByChat = (ticketDetail, threadDetail, projectInuseDetail, deliverInfo) => {
    const ticketType = ticketDetail?.ticketType;
    const threadType = threadDetail?.threadType;

    const isTicketQAOrNotice = [
        Constant.TICKET_TYPE.QA,
        Constant.TICKET_TYPE.INTERNAL_QA,
        Constant.TICKET_TYPE.EXTERNAL_QA,
        Constant.TICKET_TYPE.ESCALATION,
        Constant.TICKET_TYPE.DELEGATE,
        Constant.TICKET_TYPE.NOTICE,
        Constant.TICKET_TYPE.BROADCAST_PARENT,
        Constant.TICKET_TYPE.BROADCAST_CHILD
    ].includes(ticketType);

    if (!isTicketQAOrNotice) return true;

    const isCustomerChatThread = threadType === Constant.THREAD_CHAT_TYPE.CUSTOMER_THREAD;
    const isEscalateChatThread = threadType === Constant.THREAD_CHAT_TYPE.ESCALATION_THREAD;

    if (!isCustomerChatThread && !isEscalateChatThread) return true;

    const isTicketInProject = projectInuseDetail?.id === ticketDetail?.affiliationProject;
    if (!isTicketInProject) return true;

    return deliverInfo?.status === Constant.DELIVER_STATUS.DELIVER;
};
